import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/sthzbanner1.png'
import _imports_1 from '@/assets/image/sthztype1.png'
import _imports_2 from '@/assets/image/sthztype2.png'
import _imports_3 from '@/assets/image/sthzbanyuan2.png'
import _imports_4 from '@/assets/image/sthzbanyuan.png'
import _imports_5 from '@/assets/image/sthzback.png'
import _imports_6 from '@/assets/image/sthzliucheng3.png'
import _imports_7 from '@/assets/image/sthzjiantou.png'
import _imports_8 from '@/assets/image/sthzliucheng2.png'
import _imports_9 from '@/assets/image/sthzliucheng1.png'
import _imports_10 from '@/assets/image/sthzliucheng4.png'
import _imports_11 from '@/assets/image/sthzwhy1.png'
import _imports_12 from '@/assets/image/sthzwhy2.png'
import _imports_13 from '@/assets/image/sthzwhy3.png'


const _withScopeId = n => (_pushScopeId("data-v-702b5c78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cooperation" }
const _hoisted_2 = { class: "one container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "设纪元生态合作"),
  /*#__PURE__*/_createElementVNode("p", null, " 设纪元秉承共享共赢共创的合作理念，携手各行业、领域的合作伙伴共建工业自动化新生态，为千行百业提供自动化设计解决方案，促进方案应用落地。实现用户体验迭代、生态各方增值，共享创造价值，推动行业发展。 ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "renwu" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "type container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "合作类型", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yellow" }, null, -1))
const _hoisted_10 = { class: "type-one" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "one" }, [
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("div", null, "自动化设计方案合作伙伴")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two" }, [
  /*#__PURE__*/_createTextVNode(" 设纪元自动化设计方案生态合作平台旨在帮助为"),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"#fbb114","font-weight":"600"} }, "智能制造、工业自动化、企业自动化、数字化转型提供图纸、模型等设计资料"),
  /*#__PURE__*/_createTextVNode("，通过自研+生态相结合形成跨行业、跨领域的设计方案中心，共同为工业自动化行业快速发展助力。 ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "routine" }, "立即加入", -1))
const _hoisted_16 = {
  class: "type-one",
  style: {"margin-top":"0"}
}
const _hoisted_17 = {
  class: "right",
  style: {"margin-left":"179px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "one" }, [
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("div", null, "自动化供应链合作伙伴")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two" }, [
  /*#__PURE__*/_createTextVNode(" 设纪元自动化供应链，立足工业自动化行业领域，汇聚中国工业机器人上下游名、特、优生产制造企业，"),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"#fbb114","font-weight":"600"} }, "为合作伙伴提供技术、营销、资源等多方面的支持"),
  /*#__PURE__*/_createTextVNode("，与合作伙伴共建工业自动化新生态。 ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "routine" }, "立即加入", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"margin-left":"0px"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "banyuan1"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "banyuan2"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"course container\" data-v-702b5c78><img src=\"" + _imports_5 + "\" alt=\"\" class=\"back\" data-v-702b5c78><div class=\"title1\" data-v-702b5c78>合作流程</div><div class=\"yellow\" data-v-702b5c78></div><div class=\"course-box\" data-v-702b5c78><div class=\"one\" data-v-702b5c78><img src=\"" + _imports_6 + "\" alt=\"\" data-v-702b5c78><div data-v-702b5c78>登录设纪元</div></div><img src=\"" + _imports_7 + "\" alt=\"\" class=\"jiantou\" data-v-702b5c78><div class=\"one\" data-v-702b5c78><img src=\"" + _imports_8 + "\" alt=\"\" data-v-702b5c78><div data-v-702b5c78>企业认证</div></div><img src=\"" + _imports_7 + "\" alt=\"\" class=\"jiantou\" data-v-702b5c78><div class=\"one\" data-v-702b5c78><img src=\"" + _imports_9 + "\" alt=\"\" data-v-702b5c78><div data-v-702b5c78>审核</div></div><img src=\"" + _imports_7 + "\" alt=\"\" class=\"jiantou\" data-v-702b5c78><div class=\"one\" data-v-702b5c78><img src=\"" + _imports_10 + "\" alt=\"\" data-v-702b5c78><div data-v-702b5c78>合作商谈</div></div></div></div><div class=\"cause container\" data-v-702b5c78><div class=\"title1\" data-v-702b5c78>为什么选择设纪元</div><div class=\"yellow\" data-v-702b5c78></div><div class=\"neirong container\" data-v-702b5c78><div data-v-702b5c78><div class=\"left\" data-v-702b5c78><img src=\"" + _imports_11 + "\" alt=\"\" data-v-702b5c78></div><div class=\"name\" data-v-702b5c78><div data-v-702b5c78></div><p data-v-702b5c78>品牌销售</p></div><div class=\"foot\" data-v-702b5c78>多场景品牌展示,解锁更多商机</div></div><div data-v-702b5c78><div class=\"left\" data-v-702b5c78><img src=\"" + _imports_12 + "\" alt=\"\" data-v-702b5c78></div><div class=\"name\" data-v-702b5c78><div data-v-702b5c78></div><p data-v-702b5c78>合作生态</p></div><div class=\"foot\" data-v-702b5c78>设纪元致力打造一个各方获利的良好生态模式</div></div><div data-v-702b5c78><div class=\"left\" data-v-702b5c78><img src=\"" + _imports_13 + "\" alt=\"\" data-v-702b5c78></div><div class=\"name\" data-v-702b5c78><div data-v-702b5c78></div><p data-v-702b5c78>安全保障</p></div><div class=\"foot\" data-v-702b5c78>全站设计资料均有加密,保障合作伙伴利益</div></div></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" > 生态合作伙伴")
          ]),
          _: 1
        }),
        _hoisted_4,
        _hoisted_5
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createVNode(_component_router_link, { to: "/schemeCooperation" }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            _createVNode(_component_router_link, { to: "/chainCooperation" }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _hoisted_21
        ]),
        _hoisted_22,
        _hoisted_23
      ]),
      _hoisted_24
    ]),
    _createVNode(_component_html_footer)
  ], 64))
}